import { Action, ErrorCodes, OperationType, Position, WarningType } from "puzzle";

export const getImpersonateGridNextPageData: Action = [{
  name: 'getImpersonateUsersRequest',
  type: OperationType.action
}];


export const getImpersonateUsersWithFilter: Action = [{
  moduleName: 'ImpersonateUserPicker',
  name: 'resetGridData'
}, {
  name: 'getImpersonateUsersRequest',
  type: OperationType.action
}];


export const getImpersonateUsersRequest: Action = [{
  data: {
    method: 'get',
    template: {
      bind: {
        url: '"/impersonation/users"',
        params: '{params}'
      }
    },
  },
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  mappingName: 'gridData',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{gridData}'
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}, {
  waitForModule: true,
  moduleName: 'ImpersonateUserPicker',
  args: ['gridData'],
  name: 'setGridData'
}];

export const getImpersonateUsersInitialRequest = [{
  moduleName: 'ImpersonateUserPicker',
  name: 'getPageSize',
  mappingName: 'pageSize',
  type: OperationType.addOperationData
}, {
  data: {
    template: {
      params: {
        bind: {
          pageSize: '{pageSize}'
        }
      }
    }
  },
  type: OperationType.data
}, {
  name: 'getImpersonateUsersRequest',
  type: OperationType.action
}];


export const unableToImpersonateWarning: Action = [{
  className: 'sm info footer-centered',
  warningType: WarningType.warning,
  text: 'unableToImpersonateWarning.text',
  title: 'unableToImpersonateWarning.title',
  items: [{
    operations: [],
    btnName: 'unableToImpersonateWarning.close',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }],
  type: OperationType.warning
}];

export const switchBackImpersonatedUser: Action = [{
  data: {
    isRest: false,
    method: 'get',
    template: {
      bind: {
        url: '"switchUser/switchUserExit"',
      }
    }
  },
  type: OperationType.request
}];

export const cancelActivePingingRequest: Action = [{
  persistent: ['userName'],
  type: OperationType.addPersistentData
}, {
  name: 'favoriteImpersonatedUserRequest',
  type: OperationType.action
}, {
  name: 'stopPingingRequestForFilterCount',
  type: OperationType.action
}, {
  name: 'continueWithImpersonation',
  args: ['userName'],
  moduleName: 'ImpersonateUserPicker',
  type: OperationType.addOperationData
}, {
  persistent: ['userName'],
  type: OperationType.removePersistentData
}]


export const favoriteImpersonatedUserRequest: Action = [{
  condition: '_.get({changedData},"favorite.usernames").length',
  conditionOperations: [{
    data: {
      method: 'post',
      template: {
        bind: {
          url: '"/impersonation/markImpersontableUsersAsFavorite"',
          params: '{changedData.favorite}'
        }
      },
    },
    handleErrorStatuses: [
      ErrorCodes.FORBIDDEN,
      ErrorCodes.NOT_FOUND,
      ErrorCodes.BAD_REQUEST,
      ErrorCodes.INTERNAL_SERVER_ERROR
    ],
    mappingName: 'favoriteResponse',
    type: OperationType.request
  }, {
    data: {
      template: {
        bind: {
          responseData: '{favoriteResponse}'
        }
      }
    },
    name: 'handleRequestException',
    type: OperationType.action
  }],
  type: OperationType.conditional
}, {
  condition: '_.get({changedData},"unFavorite.usernames").length',
  conditionOperations: [{
    data: {
      method: 'post',
      template: {
        bind: {
          url: '"/impersonation/unmarkImpersonatableUsersAsFavorite"',
          params: '{changedData.unFavorite}'
        }
      },
    },
    handleErrorStatuses: [
      ErrorCodes.FORBIDDEN,
      ErrorCodes.NOT_FOUND,
      ErrorCodes.BAD_REQUEST,
      ErrorCodes.INTERNAL_SERVER_ERROR
    ],
    mappingName: 'unFavoriteResponse',
    type: OperationType.request
  }, {
    data: {
      template: {
        bind: {
          responseData: '{unFavoriteResponse}'
        }
      }
    },
    name: 'handleRequestException',
    type: OperationType.action
  }],
  type: OperationType.conditional
}];
